<nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container-fluid">
        <span class="col-4">
            <a class="navbar-brand col-4" [routerLink]="['/edition-riot']">
                <img class="logo-pfg" src="assets/LOGO_PFG_HI.png" alt="logo-pfg">
            </a>
        </span>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
                aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link text-uppercase" [routerLink]="['/edition-riot/about']">A propos</a>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle text-uppercase" id="navbarDropdown" role="button"
                       data-bs-toggle="dropdown" aria-expanded="false">Jeux</a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item text-uppercase" [routerLink]="['/edition-riot/league-of-legends']">League
                            Of Legends</a></li>
                        <li><a class="dropdown-item text-uppercase" [routerLink]="['/edition-riot/teamfight-tactics']">Teamfight
                            Tactics</a></li>
                        <li><a class="dropdown-item text-uppercase"
                               [routerLink]="['/edition-riot/legends-of-runeterra']">Legends Of Runeterra</a></li>
                    </ul>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-uppercase" href="https://playforgood.io/donation/"
                       target="_blank">Donation</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-uppercase" href="https://playforgood.io/boutique/"
                       target="_blank">Boutique</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-uppercase" [routerLink]="['/edition-riot/program']">Programme</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-uppercase" href="https://www.twitch.tv/playforgood_"
                       target="_blank">Live</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
